import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';

@Component({
  selector: 'client-sub-project-design-content',
  templateUrl: './client-sub-project-design-content.component.html',
  styleUrls: ['./client-sub-project-design-content.component.scss']
})
export class ClientSubProjectDesignContentComponent implements OnInit {
  @Input()
  project: Project;

  @Input()
  baseProject: BaseProject;

  @Input()
  ipBoard: IPBoard;

  @Output()
  save = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}
}
